import { NotificationType } from '@/features/notifications/notification-service-extension-shared/constants/app'
import {
    AcceptedOrderNotification,
    AwaitingAcceptanceOrderNotification,
    NewOrderNotification,
    PostponedOrderNotification,
} from '@/features/notifications/notification-service-extension-shared/types/app'

class NotificationGuard {
    isAwaitingAcceptanceOrder = (data: any): data is AwaitingAcceptanceOrderNotification =>
        data.type === NotificationType.AwaitingAcceptanceOrder

    isNewOrder = (data: any): data is NewOrderNotification =>
        this.isAwaitingAcceptanceOrder(data) || this.isAcceptedOrder(data)

    isAcceptedOrder = (data: any): data is AcceptedOrderNotification =>
        data.type === NotificationType.AcceptedOrder

    isPostponedOrder = (data: any): data is PostponedOrderNotification =>
        data.type === NotificationType.PostponedOrder
}

export default new NotificationGuard()
